import { render, staticRenderFns } from "./DetailAnnouncementStudent.html?vue&type=template&id=40ee7300&scoped=true&external"
import script from "./DetailAnnouncementStudent.vue?vue&type=script&lang=js"
export * from "./DetailAnnouncementStudent.vue?vue&type=script&lang=js"
import style0 from "./DetailAnnouncementStudent.scss?vue&type=style&index=0&id=40ee7300&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee7300",
  null
  
)

export default component.exports